(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["home-hero-nube"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nubeHomeRevealInit) return;
    window.__nubeHomeRevealInit = true;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function reveal(el) {
      el.classList.add('is-in');
    }

    function init() {
      var items = document.querySelectorAll('[data-nube-reveal]');
      if (!items.length) return;

      if (prefersReduced || !('IntersectionObserver' in window)) {
        items.forEach(reveal);
        return;
      }

      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      items.forEach(function (el) { observer.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["offer-card-nube"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nubeOffersRevealInit) return;
    window.__nubeOffersRevealInit = true;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function reveal(el) {
      el.classList.add('is-in');
    }

    function init() {
      var items = document.querySelectorAll('[data-nube-offer-reveal]');
      if (!items.length) return;

      if (prefersReduced || !('IntersectionObserver' in window)) {
        items.forEach(reveal);
        return;
      }

      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      items.forEach(function (el) { observer.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["offer-hero-nube"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nubeOffersRevealInit) return;
    window.__nubeOffersRevealInit = true;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function reveal(el) {
      el.classList.add('is-in');
    }

    function init() {
      var items = document.querySelectorAll('[data-nube-offer-reveal]');
      if (!items.length) return;

      if (prefersReduced || !('IntersectionObserver' in window)) {
        items.forEach(reveal);
        return;
      }

      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      items.forEach(function (el) { observer.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["offer-tiers-nube"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__nubeOffersRevealInit) return;
    window.__nubeOffersRevealInit = true;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function reveal(el) {
      el.classList.add('is-in');
    }

    function init() {
      var items = document.querySelectorAll('[data-nube-offer-reveal]');
      if (!items.length) return;

      if (prefersReduced || !('IntersectionObserver' in window)) {
        items.forEach(reveal);
        return;
      }

      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      items.forEach(function (el) { observer.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-promo-card"] && !Shopify.designMode) return;
  try {
    (function () {
    function repairQuantitySelector(component) {
      if (!component) return;
      // Horizon fija `serverDisabledMinus` en el primer render y nunca lo
      // vuelve a evaluar; para el mínimo de este producto (1) queremos que
      // Horizon controle el botón "-" dinámicamente en vez de dejarlo
      // deshabilitado para siempre. No es deuda técnica: es un fix de un
      // comportamiento nativo de `component-quantity-selector.js`.
      component.serverDisabledMinus = false;
      if (typeof component.updateButtonStates === 'function') {
        component.updateButtonStates();
      }
    }

    var TRUCK_SVG =
      '<svg viewBox="0 0 24 24"><rect x="2" y="8" width="13" height="9" rx="1.4"/><path d="M15 11h3.4l3.1 3.3V17H15z"/><circle cx="6.5" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/></svg>';

    function updatePromo(card) {
      var tier2Qty = parseInt(card.dataset.tier2Qty, 10) || 2;
      var tier3Qty = parseInt(card.dataset.tier3Qty, 10) || 3;
      var tier2Percent = card.dataset.tier2DiscountPercent || '20';
      var tier3Percent = card.dataset.tier3DiscountPercent || '30';

      var details = card.closest('.product-details');
      var quantityInput = details
        ? details.querySelector('.quantity-selector input[type="number"]')
        : null;
      var currentQuantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

      var cartBubble = document.querySelector('.cart-bubble__text-count');
      var cartQuantity = cartBubble ? parseInt(cartBubble.textContent, 10) || 0 : 0;

      var totalQuantity = cartQuantity + currentQuantity;

      var tier = 1;
      if (totalQuantity >= tier3Qty) {
        tier = 3;
      } else if (totalQuantity >= tier2Qty) {
        tier = 2;
      }

      card.querySelectorAll('.nube-promo__dc').forEach(function (dot) {
        var dotNumber = parseInt(dot.dataset.dot, 10);
        dot.classList.toggle('on', dotNumber <= tier);
        dot.classList.toggle('sigue', dotNumber === tier + 1);
      });

      // La celda 1 (envío gratis) siempre queda "won": va incluido desde la
      // primera unidad, no es un escalón que haya que desbloquear.
      card.querySelectorAll('.nube-promo__cell').forEach(function (cell) {
        var cellNumber = parseInt(cell.dataset.card, 10);
        cell.classList.toggle('won', cellNumber <= tier);
      });

      var fill = card.querySelector('[data-nube-promo-fill]');
      if (fill) {
        fill.style.transform = 'scaleX(' + (tier === 1 ? 0 : tier === 2 ? 0.5 : 1) + ')';
      }

      var title = card.querySelector('[data-nube-promo-title]');
      var subtitle = card.querySelector('[data-nube-promo-subtitle]');
      var badge = card.querySelector('[data-nube-promo-badge]');

      if (tier === 1) {
        var remainingTo2 = tier2Qty - totalQuantity;
        if (title) title.textContent = '¡Envío gratis incluido!';
        if (subtitle) subtitle.innerHTML = 'Suma ' + remainingTo2 + ' más y llévate <em>' + tier2Percent + '% off</em>';
      } else if (tier === 2) {
        var remainingTo3 = tier3Qty - totalQuantity;
        if (title) title.textContent = '¡' + tier2Percent + '% de descuento desbloqueado!';
        if (subtitle) subtitle.innerHTML = 'Suma ' + remainingTo3 + ' más y llévate <em>' + tier3Percent + '% off extra</em>';
      } else {
        if (title) title.textContent = '¡Te llevas todo!';
        if (subtitle) {
          subtitle.innerHTML = 'Envío gratis + <em>' + tier3Percent + '% off</em> ya aplicados';
        }
      }

      if (badge) {
        badge.classList.remove('pend', 'won', 'full');
        if (tier === 3) {
          badge.classList.add('full');
          badge.innerHTML =
            '<span class="nube-promo__spark" style="--x:-16px;--y:-11px;--d:0ms;--c:#750785"></span>' +
            '<span class="nube-promo__spark" style="--x:15px;--y:-13px;--d:60ms;--c:#d9ae63"></span>' +
            '<span class="nube-promo__spark" style="--x:-15px;--y:12px;--d:120ms;--c:#158A3C"></span>' +
            '<span class="nube-promo__spark" style="--x:17px;--y:10px;--d:180ms;--c:#750785"></span>' +
            '<span class="nube-promo__num">' + tier3Percent + '%</span>';
        } else if (tier === 2) {
          badge.classList.add('won');
          badge.innerHTML = '<span class="nube-promo__num">' + tier2Percent + '%</span>';
        } else {
          badge.classList.add('pend');
          badge.innerHTML = TRUCK_SVG + '<i></i>';
        }
      }
    }

    // Reescribe el texto de stock como gancho de urgencia ("¡Solo quedan N!
    // en talla X", "¡Última unidad! en talla X" cuando N es 1) y agrega la
    // talla seleccionada. La urgencia va primero en la frase a propósito —
    // es lo primero que lee el ojo. `<product-inventory>` se reemplaza por
    // completo (morph) cada vez que cambia la variante, asi que esto se
    // re-aplica via MutationObserver en vez de una sola vez.
    // `data-nube-stock-done` evita reprocesar el mismo nodo dos veces
    // (nuestra propia escritura tambien dispara el observer).
    function styleStock(details) {
      var statusEl = details.querySelector('.product-inventory__status');
      var textEl = details.querySelector('.product-inventory__text');
      var iconEl = details.querySelector('.product-inventory__icon');
      if (!statusEl || !textEl || !iconEl || textEl.dataset.nubeStockDone === 'true') return;

      var sizeInput = details.querySelector(
        'input[data-option-name="Talla"]:checked, input[data-option-name="Tallas"]:checked'
      );
      var sizeSuffix = sizeInput && sizeInput.value ? ' en talla ' + sizeInput.value : '';
      var isLow = iconEl.classList.contains('product-inventory__icon-low');

      statusEl.classList.remove('nube-stock--last', 'nube-stock--solo-short');

      // La 2XL solo se fabrica con short: con 2XL + pantalón se explica eso
      // en vez del "Agotado" genérico, para que la clienta cambie a short.
      var bottomInput = Array.prototype.find.call(
        details.querySelectorAll('input[data-option-name]:checked'),
        function (input) {
          return /inferior/i.test(input.dataset.optionName || '');
        }
      );
      var isPantalon = bottomInput && /^pantal[oó]n$/i.test((bottomInput.value || '').trim());
      if (sizeInput && sizeInput.value === '2XL' && isPantalon) {
        statusEl.classList.add('nube-stock--solo-short');
        textEl.textContent = 'Talla 2XL disponible solo en short';
        textEl.dataset.nubeStockDone = 'true';
        return;
      }

      if (isLow) {
        var match = textEl.textContent.match(/\d+/);
        var count = match ? parseInt(match[0], 10) : null;
        if (count === 1) {
          statusEl.classList.add('nube-stock--last');
          textEl.textContent = '¡Última unidad!' + sizeSuffix;
        } else if (count !== null) {
          textEl.textContent = '¡Solo quedan ' + count + '!' + sizeSuffix;
        } else if (sizeSuffix) {
          textEl.textContent = textEl.textContent.trim() + sizeSuffix;
        }
      } else if (iconEl.classList.contains('product-inventory__icon-in_stock')) {
        textEl.textContent = 'Disponible' + sizeSuffix;
      } else if (sizeSuffix) {
        textEl.textContent = textEl.textContent.trim() + sizeSuffix;
      }

      textEl.dataset.nubeStockDone = 'true';
    }

    function bindSizeSuffix(details) {
      var inventoryEl = details.querySelector('product-inventory');
      if (!inventoryEl || inventoryEl.dataset.nubeSizeSuffixBound === 'true') return;
      inventoryEl.dataset.nubeSizeSuffixBound = 'true';

      styleStock(details);

      new MutationObserver(function () {
        styleStock(details);
      }).observe(inventoryEl, { childList: true, subtree: true, characterData: true });
    }

    // El botón "Agregar al carrito" flotante nativo de Horizon
    // (sticky-add-to-cart) decide cuándo mostrarse observando
    // `.buy-buttons-block`, pero ese contenedor lo volvimos
    // `display:contents` para poder intercalar cantidad → promo → botón
    // (ver el bloque de CSS "ORDEN VISUAL" más arriba) — sin caja real,
    // Horizon nunca detecta que se hizo scroll más allá del botón. Se
    // replica la misma lógica observando el botón real en su lugar.
    function bindStickyAddToCartFix(details) {
      var stickyBar = document.querySelector('.sticky-add-to-cart__bar');
      var addToCartComponent = details.querySelector('add-to-cart-component');
      var footer = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
      if (!stickyBar || !addToCartComponent || stickyBar.dataset.nubeStickyFixBound === 'true') return;
      stickyBar.dataset.nubeStickyFixBound = 'true';

      var isStuck = false;
      var hiddenByBottom = false;

      function show() {
        isStuck = true;
        stickyBar.dataset.stuck = 'true';
      }

      function hide() {
        isStuck = false;
        stickyBar.dataset.stuck = 'false';
      }

      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        if (!entry.isIntersecting && !isStuck) {
          var rect = entry.target.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top < 0) show();
        } else if (entry.isIntersecting && isStuck) {
          hiddenByBottom = false;
          hide();
        }
      }).observe(addToCartComponent);

      if (footer) {
        new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            if (!entry) return;
            if (entry.isIntersecting && isStuck) {
              hiddenByBottom = true;
              hide();
            } else if (!entry.isIntersecting && hiddenByBottom) {
              var rect = addToCartComponent.getBoundingClientRect();
              if (rect.bottom < 0 || rect.top < 0) {
                hiddenByBottom = false;
                show();
              }
            }
          },
          { rootMargin: '200px 0px 0px 0px' }
        ).observe(footer);
      }
    }

    // El badge de "-X%" junto al precio tachado se fija en el primer
    // render (server-side, en la variante con la que cargó la página).
    // Cuando el cliente elige otra variante con precio distinto, Horizon
    // reemplaza el contenedor del precio con el nuevo HTML del servidor
    // (product-price.js), pero eso no toca nuestro <style> — así que el
    // badge se quedaría pegado al % de la variante inicial si no lo
    // recalculamos aquí, a partir del mismo evento que usa el propio precio
    // del tema (shopify:product:select) y el `resource` (JSON de la
    // variante nueva) que trae.
    function updateDiscountBadge(details, resource) {
      var pct = 0;
      if (resource && resource.compare_at_price && resource.price && resource.compare_at_price > resource.price) {
        pct = Math.round(((resource.compare_at_price - resource.price) * 100) / resource.compare_at_price);
      }
      details.style.setProperty('--nube-discount-badge', pct > 0 ? '"-' + pct + '%"' : 'none');
    }

    // Texto del botón nativo "Agregar al carrito" — lo reetiquetamos en
    // mayúsculas ("AGREGAR AL CARRITO"). El texto vive como nodo de texto
    // suelto dentro del <button> (entre el ícono y el estado "agregado"),
    // así que se busca por tipo de nodo en vez de por selector. Igual que
    // el badge de descuento, hay que reaplicarlo en cada
    // `shopify:product:select` porque Horizon reemplaza (morph) el botón
    // completo con el HTML del servidor al cambiar de variante, que trae
    // el texto original.
    var ADD_TO_CART_LABEL = 'AGREGAR AL CARRITO';

    function relabelAddToCart(details) {
      var btn = details.querySelector('[data-testid="standalone-add-to-cart"]');
      if (!btn) return;

      for (var i = 0; i < btn.childNodes.length; i++) {
        var node = btn.childNodes[i];
        if (node.nodeType === 3 && node.textContent.trim().length > 0) {
          node.textContent = ADD_TO_CART_LABEL;
          return;
        }
      }
    }

    function bindDiscountBadge(details) {
      var section = details.closest('.shopify-section, dialog');
      if (!section || section.dataset.nubeDiscountBadgeBound === 'true') return;
      section.dataset.nubeDiscountBadgeBound = 'true';

      section.addEventListener('shopify:product:select', function (event) {
        if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

        event.promise
          .then(function (result) {
            var detail = result && result.detail;
            if (!detail) return;
            updateDiscountBadge(details, detail.resource);
            relabelAddToCart(details);
          })
          .catch(function (error) {
            if (error && error.name !== 'AbortError') console.warn('[product-promo-card] Event promise rejected:', error);
          });
      });
    }

    function init() {
      document.querySelectorAll('[data-nube-promo-card]').forEach(function (card) {
        if (card.dataset.nubePromoBound === 'true') return;
        card.dataset.nubePromoBound = 'true';

        var details = card.closest('.product-details');
        if (!details) return;

        var quantityComponent = details.querySelector('quantity-selector-component');

        repairQuantitySelector(quantityComponent);

        details.addEventListener('quantity-selector:update', function () {
          repairQuantitySelector(quantityComponent);
          updatePromo(card);
        });

        bindSizeSuffix(details);
        bindStickyAddToCartFix(details);
        bindDiscountBadge(details);
        relabelAddToCart(details);

        var cartBubble = document.querySelector('.cart-bubble__text-count');
        if (cartBubble) {
          var lastCartQuantity = cartBubble.textContent.trim();
          new MutationObserver(function () {
            var currentCartQuantity = cartBubble.textContent.trim();
            if (currentCartQuantity !== lastCartQuantity) {
              lastCartQuantity = currentCartQuantity;
              updatePromo(card);
            }
          }).observe(cartBubble, { childList: true, characterData: true, subtree: true });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
